module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-1-082c768a.png";